import { withUpdate } from '@polyu-dip/model-core'
import { Instance, types } from 'mobx-state-tree'
import { BaseEntityModel } from './base-entity'
import { NameModel } from './languages-json'

export const TagTypeModel = types
  .compose(BaseEntityModel, NameModel)
  .props({
    id: types.string,
    name: types.string,
    isDisabled: types.boolean,
    order: types.number,
  })
  .extend(withUpdate)
  .named('TagTypeModel')

export type TagType = Instance<typeof TagTypeModel>
